import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import NotFoundComponent from '@routes/error';
import PageLoading from '@shared/components/loading';

const LazySalesforceConnections = lazy(() => import('./index'));

const SalesForceRoutes = () => {
  return (
    <Route path=':projectId'>
      <Route
        path='connection'
        element={
          <Suspense fallback={<PageLoading />}>
            <LazySalesforceConnections />
          </Suspense>
        }
        errorElement={<NotFoundComponent />}
      />
    </Route>
  );
};

export default SalesForceRoutes;
